<era-pane>
  <h5 class="small-caps"
      i18n>Erase device</h5>
  <p>
    <small class="text-muted">Upon receiving this command, the device immediately erases itself. No warning is given to
      the user. This command
      is performed immediately even if the device is locked.</small>
  </p>
  <form [formGroup]="eraseDeviceForm"
        (ngSubmit)="onSubmit()"
        novalidate>
    @if (apple() | os: { macOS: '>=10.8' }) {
      <div>
        <label class="form-label"
               for="EraseDevicePin"
               i18n>Pin:</label>
        <input id="EraseDevicePin"
               type="text"
               class="form-control"
               formControlName="eraseDevicePin"
               [class.is-invalid]="eraseDevicePin?.invalid && eraseDevicePin?.touched" />
        @if (eraseDevicePin?.invalid && eraseDevicePin?.touched) {
          <div class="invalid-feedback">
            @if (eraseDevicePin?.errors?.required) {
              <div>A pin is required.</div>
            }
            @if (eraseDevicePin?.errors?.minLength) {
              <div>The pin should be 6 digits long.</div>
            }
          </div>
        }
      </div>
    }
    @if (apple() | os: { iOS: '>=11.0' }) {
      <div class="form-check">
        <label class="form-check-label">
          <input type="checkbox"
                 class="form-check-input"
                 formControlName="preserveDataPlan" /> Preserve data plan,
          <small>if a data plan exists on the device, it will be preserved.</small>
        </label>
      </div>
    }
    @if (apple() | os: { iOS: '>=11.3' }) {
      <div class="form-check">
        <label class="form-check-label">
          <input type="checkbox"
                 class="form-check-input"
                 formControlName="disallowProximitySetup" /> Disallow Proximity
          Setup,
          <small>on the next reboot Proximity Setup is not allowed and the pane in Setup Assistant will be
            skipped.</small>
        </label>
      </div>
    }
  </form>

  <!-- Modal -->
  <ng-template #content
               let-modal>
    <div class="modal-header">
      <h4 class="modal-title"
          id="modal-title">Erase device</h4>
      <button type="button"
              class="btn-close"
              aria-label="Close"
              (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <h1 class="col-auto my-auto text-danger">
          <fa-icon icon="exclamation-triangle"
                   class="h1"></fa-icon>
        </h1>
        <p class="col my-auto text-danger fw-bold">Are you sure you want to erase the device?</p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button"
              class="btn btn-outline-danger"
              (click)="onSubmit()">ERASE THE DEVICE</button>
      <button type="button"
              ngbAutofocus
              class="btn btn-primary"
              (click)="modal.dismiss('cancel click')">Cancel</button>
    </div>
  </ng-template>

  <button type="button"
          class="btn btn-primary mt-2"
          (click)="showEraseDeviceModal(content)">Erase</button>
</era-pane>